module.exports = __webpack_public_path__ + "img/faqs.59ed3e21.svg";